// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img-locate {
    width: 30px;
    float: right;
}

a:link {
    text-decoration: underline;
}

.choose-language {
    position: absolute;
    top: 16px;
    right: 16px;
}


.dropdown-item {
    padding: 1rem 1rem !important;
}

.menu-item {
    min-width: 140px;
    cursor: pointer;
}

.dropdown-item:hover {
    background-color: #0B6B59;
}


.menu-item:focus {
    background-color: #0B6B59;
}

.menu-item:hover {
    background-color: #0B6B59;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvZ2luLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0lBQ1gsWUFBWTtBQUNoQjs7QUFFQTtJQUNJLDBCQUEwQjtBQUM5Qjs7QUFFQTtJQUNJLGtCQUFrQjtJQUNsQixTQUFTO0lBQ1QsV0FBVztBQUNmOzs7QUFHQTtJQUNJLDZCQUE2QjtBQUNqQzs7QUFFQTtJQUNJLGdCQUFnQjtJQUNoQixlQUFlO0FBQ25COztBQUVBO0lBQ0kseUJBQXlCO0FBQzdCOzs7QUFHQTtJQUNJLHlCQUF5QjtBQUM3Qjs7QUFFQTtJQUNJLHlCQUF5QjtBQUM3QiIsImZpbGUiOiJsb2dpbi5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmltZy1sb2NhdGUge1xuICAgIHdpZHRoOiAzMHB4O1xuICAgIGZsb2F0OiByaWdodDtcbn1cblxuYTpsaW5rIHtcbiAgICB0ZXh0LWRlY29yYXRpb246IHVuZGVybGluZTtcbn1cblxuLmNob29zZS1sYW5ndWFnZSB7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIHRvcDogMTZweDtcbiAgICByaWdodDogMTZweDtcbn1cblxuXG4uZHJvcGRvd24taXRlbSB7XG4gICAgcGFkZGluZzogMXJlbSAxcmVtICFpbXBvcnRhbnQ7XG59XG5cbi5tZW51LWl0ZW0ge1xuICAgIG1pbi13aWR0aDogMTQwcHg7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4uZHJvcGRvd24taXRlbTpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogIzBCNkI1OTtcbn1cblxuXG4ubWVudS1pdGVtOmZvY3VzIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjMEI2QjU5O1xufVxuXG4ubWVudS1pdGVtOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjMEI2QjU5O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/login/login/login.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wpCAAwpC","sourcesContent":[".img-locate {\n    width: 30px;\n    float: right;\n}\n\na:link {\n    text-decoration: underline;\n}\n\n.choose-language {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n}\n\n\n.dropdown-item {\n    padding: 1rem 1rem !important;\n}\n\n.menu-item {\n    min-width: 140px;\n    cursor: pointer;\n}\n\n.dropdown-item:hover {\n    background-color: #0B6B59;\n}\n\n\n.menu-item:focus {\n    background-color: #0B6B59;\n}\n\n.menu-item:hover {\n    background-color: #0B6B59;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
